import Link from "next/link"
import { Rocket, DollarSign, Handshake, ArrowRight, Code, Database } from "lucide-react"

export default function SponsorshipCallout() {
  return (
    <section className="py-16 bg-gradient-to-r from-uiuc-blue to-uiuc-orange">
      <div className="container-custom">
        <div className="text-center text-white">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6">
            <Rocket size={32} />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-4">Partner with a Full-Stack Engineer & Cyber Specialist</h2>

          <p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
            Join me in building the next generation of digital solutions—specializing in full-stack engineering with Python, Django, React, and JavaScript, plus robust cybersecurity solutions. Cloud and data services available as additional capabilities.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 max-w-4xl mx-auto">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6">
              <DollarSign className="mx-auto mb-4 text-yellow-300" size={32} />
              <h3 className="text-lg font-semibold mb-2">Tech Investment</h3>
              <p className="text-sm opacity-80">
                Seeking sponsors and investors for full-stack applications and cybersecurity solutions
              </p>
            </div>

            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6">
              <Handshake className="mx-auto mb-4 text-green-300" size={32} />
              <h3 className="text-lg font-semibold mb-2">Strategic Collaboration</h3>
              <p className="text-sm opacity-80">
                Collaborate on innovative platforms built with Python, Django, React, and secure architectures
              </p>
            </div>

            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6">
              <Code className="mx-auto mb-4 text-uiuc-orange" size={32} />
              <h3 className="text-lg font-semibold mb-2">Full-Stack & Security</h3>
              <p className="text-sm opacity-80">Empowering businesses with modern full-stack engineering and cybersecurity</p>
            </div>
          </div>

          <div className="flex flex-row flex-wrap gap-3 justify-center w-full">
            <Link
              href="/contact?type=sponsor"
              className="inline-flex items-center px-5 py-2.5 sm:px-6 sm:py-3 bg-white text-uiuc-blue text-sm sm:text-base font-semibold rounded-full hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              <span className="hidden sm:inline">Contact for Sponsorship</span>
              <span className="sm:hidden">Sponsor</span>
              <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5" />
            </Link>
            <Link
              href="/projects"
              className="inline-flex items-center px-5 py-2.5 sm:px-6 sm:py-3 border-2 border-white text-white text-sm sm:text-base font-semibold rounded-full hover:bg-white hover:text-uiuc-blue transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
            >
              View Projects
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
